export default {
    KEY: 'maZj2KK7YIGw04moj',
    TEMPLATE: 'temphostll1',
    SERVICE: 'Hostinger',

};